






import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";

@Component
class ActionAssetHide extends Vue {
  @Mutation("wallet/mixin/SET_HIDDEN") setHidden;

  @State(state => state.wallet.mixin.hidden) hidden;

  handleHiddenClick() {
    this.setHidden(!this.hidden);
  }
}
export default ActionAssetHide;
